import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../../store";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../../util/apiClient";
import MyDialogComponent from "../../Common/MyDialogComponent";
import EditForm from './EditForm';
import Formulaire from "./Formulaire";
import { addModules, editModule, setObjModule, setOpenDialogModule, setValueEdit } from "./moduleSlice";





const AddModule = () => {

    //redux
    const dispatch = useDispatch()
    const { openDialogModule, objModule, valueEdit } = useSelector((state: IReduxState) => state.module);

    //hooks
    const [valueModule, setValueModule] = useState("");


    const handleSave = async () => {
        try {
            const apiPayload = { libelleModule: valueModule }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/creermodule", apiPayload)
            if (res.status === 1) {

                const newModule = { ...res.data, id: res.data.idModule, libelle: res.data.libelleModule }
                dispatch(addModules(newModule))
                dispatch(setOpenDialogModule(false))
            } else {
                console.log("status !==1")
            }
        } catch (error) {
            console.log("🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    }


    const editItem = async () => {
        try {
            const apiPayload = { idModule: objModule.idModule, libelleModule: valueEdit }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/modifiermodule", apiPayload)
            if (res.status === 1) {
                const newModule = { ...res.data, id: res.data.idModule, libelle: res.data.libelleModule }
                dispatch(editModule(newModule))
                dispatch(setOpenDialogModule(false))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };

    const handleOpen = () => {
        dispatch(setOpenDialogModule(true));
        dispatch(setObjModule({}));
        setValueModule("")
    };

    const handleClose = () => {
        dispatch(setOpenDialogModule(false));
    };


    return (
        <div>
            <MyDialogComponent
                dialogTitle={`${Object.keys(objModule).length > 0 ? "Modifier le module" : "Créer un module"}`}
                dialogContent={
                    Object.keys(objModule).length > 0
                        ? <EditForm setValueEdit={setValueEdit} valueEdit={valueEdit} />
                        : <Formulaire setValueModule={setValueModule} valueModule={valueModule} />
                }
                handleSave={
                    Object.keys(objModule).length > 0
                        ? editItem
                        : handleSave
                }
                openDialog={openDialogModule}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />
        </div>
    );
}

export default AddModule;
